import { handleUrl, myHeadersWithTokenContentType } from '../global';
import {
  GetCompletionResponseData,
  GetScientificTreatmentProps,
  UpdateScientificTreatmentData,
  UpdateScientificTreatmentProps,
  FactorsSections,
  UpdateInferencesSections,
} from './types';

const getScientificTreatment = (
  osId: number
): Promise<GetScientificTreatmentProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const BaseUrl = handleUrl();
  return fetch(
    `${BaseUrl}/api/V1/work-orders/${osId}/manual-calculation-report`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

const updateScientificTreatment = (
  osId: number,
  data: UpdateScientificTreatmentData,
  section: UpdateInferencesSections | FactorsSections
): Promise<UpdateScientificTreatmentProps> => {
  const requestOptions = {
    method: 'PATCH',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data),
  };
  const BaseUrl = handleUrl();
  return fetch(
    `${BaseUrl}/api/V1/work-orders/${osId}/manual-calculation-report/sections/${section}`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

const getCompletion = (osId: number): Promise<GetCompletionResponseData> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const BaseUrl = handleUrl();
  return fetch(
    `${BaseUrl}/api/V1/work-orders/${osId}/manual-calculation-report/completion`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export default {
  getScientificTreatment,
  updateScientificTreatment,
  getCompletion,
};
